import React from 'react';
import PropTypes from 'prop-types';
import ConfirmDialog from "../common/ConfirmDialog";

/**
 * Displays all the of the confirmation modals related to the Tenant Admin Data Extracts screen.
 *
 * @param {Object} props - see propTypes
 * @returns {JSX.Element} - all the of the confirmation modals related to the Tenant Admin Data Extracts screen
 */
const ConfirmDialogs = (props) => {
    return (
        <div>
            <ConfirmDialog confirmText="Clear Changes"
                           cancelText="Cancel"
                           headerText="Are you sure you want to clear all changes?"
                           descriptionText="You will not be able to recover any changes you made to the configurations."
                           isOpen={props.isOpen}
                           onClose={() => {
                               props.setIsOpen(false)
                           }}
                           onConfirm={props.clear}/>
            <ConfirmDialog confirmText={"Delete"}
                           cancelText="Cancel"
                           headerText={"Are you sure you want to delete this access key?"}
                           descriptionText="You will not be able to recover this access key after deletion."
                           isOpen={props.isOpenDeleteAccessKey}
                           onClose={() => {
                               props.setIsOpenDeleteAccessKey(false)
                           }}
                           onConfirm={() => props.deleteUser(props.deleteUserName)}/>
            <ConfirmDialog confirmText={props.accessKeyStatus.statusVerb}
                           cancelText="Cancel"
                           headerText={"Are you sure you want to "
                               + props.accessKeyStatus.statusVerb.toLowerCase()
                               + " this access key?"}
                           descriptionText="Only active access keys have permission to view data extract files in AWS S3."
                           isOpen={props.isOpenUpdateAccessKeyStatus}
                           onClose={() => {
                               props.setIsOpenUpdateAccessKeyStatus(false)
                           }}
                           onConfirm={() => props.updateAccessKeyStatus(
                               props.accessKeyStatus.userName,
                               props.accessKeyStatus.status
                           )}/>
        </div>
    )
}

ConfirmDialogs.propTypes = {
    isOpen: PropTypes.bool.isRequired,
    setIsOpen: PropTypes.func.isRequired,
    clear: PropTypes.func.isRequired,
    isOpenDeleteAccessKey: PropTypes.bool.isRequired,
    setIsOpenDeleteAccessKey: PropTypes.func.isRequired,
    deleteUserName: PropTypes.string.isRequired,
    deleteUser: PropTypes.func.isRequired,
    accessKeyStatus: PropTypes.object,
    isOpenUpdateAccessKeyStatus: PropTypes.bool.isRequired,
    setIsOpenUpdateAccessKeyStatus: PropTypes.func.isRequired,
    updateAccessKeyStatus: PropTypes.func.isRequired
};

export default ConfirmDialogs;
